"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _WebcamCapture = _interopRequireDefault(require("./WebcamCapture"));

var _WebcamImage = _interopRequireDefault(require("./WebcamImage"));

var _Constant = require("../Constant");

var _AllowedImageFormats = require("./AllowedImageFormats");

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  background-color: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Container = _styledComponents.default.div(_templateObject(), _Constant.Color.WHITE);

var WebcamContainer = function WebcamContainer(_ref) {
  var handleScreenshotData = _ref.handleScreenshotData,
      captureGuidelineOverlay = _ref.captureGuidelineOverlay,
      screenshotFormat = _ref.screenshotFormat,
      previewImage = _ref.previewImage;
  return /*#__PURE__*/_react.default.createElement(Container, null, previewImage && /*#__PURE__*/_react.default.createElement(_WebcamImage.default, {
    image: previewImage
  }), !previewImage && /*#__PURE__*/_react.default.createElement(_WebcamCapture.default, {
    disabled: !!previewImage,
    onScreenshot: function onScreenshot(image, canvas) {
      canvas.toBlob(function (blob) {
        return handleScreenshotData({
          blob: blob,
          image: image
        });
      }, screenshotFormat);
    },
    captureGuidelineOverlay: captureGuidelineOverlay,
    screenshotFormat: screenshotFormat
  }));
};

WebcamContainer.propTypes = {
  /** An URL to an image that will be overlaid on top of the webcam footage. */
  captureGuidelineOverlay: _propTypes.default.string,

  /** The file format for the image. */
  screenshotFormat: _propTypes.default.oneOf(_AllowedImageFormats.ALLOWED_IMAGE_FORMATS),

  /** A base 64 encoded iamge string to display it as a review/preview, or null to show the webcam footage. */
  previewImage: _propTypes.default.string,

  /** A two argument function that accepts the base64 image and the file blob in the desired format. */
  handleScreenshotData: _propTypes.default.func.isRequired
};
WebcamContainer.defaultProps = {
  captureGuidelineOverlay: null,
  previewImage: null,
  screenshotFormat: 'image/jpeg'
};
var _default = WebcamContainer;
exports.default = _default;